module.exports = __webpack_public_path__ + "img/4.f6bc5b7e.jpg";